'use strict';

require('foundation-abide');
require('foundation-reveal');
require('foundation-accordion');

var $ = require('jquery');

var basePage = require('./base-page.js');
var gridHeights = require('./ui/grid-heights.js');
var userReviewForm = require('./forms/user-review-form.js');
var introPanel = require('./components/intro-panel.js');
var slickslider = require('./components/slickslider.js');
var fullScreenGallery = require('./components/full-screen-gallery.js');
var comments = require('./components/comments.js');
var layout = require('./ui/layout.js');
var preferredSourcesGoogleWidget = require('./components/preferred-sources-google-widget.js');

var cssClasses = {
	siteHeader: 'site-header',
	siteBody: 'site-body'
};

function initialiseSlickSlider() {
    if ($('.gallery-slickslider:not(.gallery-slickslider--article-list)').length > 0) {
		slickslider.init($('.gallery-slickslider:not(.gallery-slickslider--article-list)'),{
			lazyLoad: 'ondemand',
			autoplay : false,
			slidesToScroll: 1,
			slidesToShow: 4,
			speed: 300,
			responsive: [
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2
					}
				}
			],
			variableWidth: true
		});
	}
	if ($('.gallery-slickslider--article-list').length > 0) {
		slickslider.init($('.gallery-slickslider--article-list'),{
			lazyLoad: 'ondemand',
			autoplay : false,
			slidesToScroll: 1,
			slidesToShow: 3,
			speed: 300,
			variableWidth: true,
			responsive: [
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						adaptiveHeight: true,
						variableWidth: false
					}
				}
			]
		});
	}
}

function initialiseFullScreenGallery() {
	fullScreenGallery.init($('.gallery-slickslider:not(.gallery-slickslider--article-list):not(.gallery-slickslider--landing-page)'));
	fullScreenGallery.init($('.thumbnail-gallery'));
}

function observerCallback(mutations) {
	mutations.forEach(function() {
		var zIndexValue = $.findByBem(cssClasses.siteHeader).css('z-index');
		if (zIndexValue) {
			zIndexValue = parseInt(zIndexValue);
			$.findByBem(cssClasses.siteBody).css('z-index', zIndexValue + 1);
		}
	});
}

function isMobileOrTablet() {
	return layout.isMobile() || layout.getScreenSize() === 'L';
}

/*
	If a mobile or tablet review page has a hero ad takeover, code is injected by AdOps to add additional style css.
	This results in an increase of the z-index of the site-header that contains the primary navigation.
	A side-effect is the product card's gallery being overlapped, covering the 'X' to close the gallery.
	To fix this, we need to set the z-index of the site-body div to be higher than the AdOps value.
	This function observes the site-header for changes to its style attribute and increase the z-index of the site-body accordingly.
	We could use Css classes to achieve this, but if AdOps changes the z-index value, we would need to potentially update our css again.
	From testing, this occurs on S, M and L viewports.
*/
function initialiseMobileSiteBodyForAdTakeover() {
	if (!isMobileOrTablet()) {
		return;
	}

	if ($('body.takeover:has(.product-card').length === 0) {
		return;
	}

	var config = { attributes : true, attributeFilter : ['style'] };
	var observer = new MutationObserver(observerCallback);
	observer.observe($.findByBem(cssClasses.siteHeader).get(0), config);
}

basePage.init = function() {
	basePage.initBasePage();

	gridHeights.init();
	introPanel.init();

	if ($('#brightcovePlayer').length > 0) {
		require.ensure(['brightcove'], function() {
			require('brightcove');
		}, 'tgBrightcove');
	}

	initialiseSlickSlider();
	initialiseFullScreenGallery();
	initialiseMobileSiteBodyForAdTakeover();

	userReviewForm.init();

	preferredSourcesGoogleWidget.init();

	if ($('#disqus_thread').length > 0) {
		comments.init();
	}
};

module.exports = basePage;